import { changePassword } from "@/api/auth";
import PasswordInput from "@/components/form/PasswordInput";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@/components/ui/dialog";
import { toast } from "@/hooks/use-toast";
import React, { useEffect, useState } from "react";

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  userId: number;
}
function ChangePasswordDialog({ isOpen, setIsOpen, userId }: Props) {
  const [password, setPassword] = useState<string>("");
  const [newPassword, setNewPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [err, setErr] = useState<string>("");

  useEffect(() => {
    setErr("");
    if (confirmPassword !== newPassword) {
      setErr("New passwords do not match");
    }
  }, [confirmPassword, newPassword]);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (confirmPassword !== newPassword) {
      setErr("New passwords do not match.");
      return;
    }
    setErr("");
    try {
      // Call API to change password
      await changePassword({ currentPassword: password, newPassword });

      setIsOpen(false);
      toast({
        title: "Password changed",
        description: "Your password has been changed successfully.",
      });
    } catch (err: any) {
      console.error(err);
      setErr(
        err.response.data.message || "An error occurred. Please try again."
      );
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent onInteractOutside={(e) => {
        e.preventDefault();
      }}>
        <DialogTitle>Change Password</DialogTitle>
        <DialogDescription>
          Enter your current and new passwords.
        </DialogDescription>
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <PasswordInput
            label="Current Password"
            value={password}
            setValue={setPassword}
          />
          <PasswordInput
            label="New Password"
            value={newPassword}
            setValue={setNewPassword}
          />
          <PasswordInput
            label="Confirm Password"
            value={confirmPassword}
            setValue={setConfirmPassword}
          />
          {err && <div className="text-red-500 text-sm">{err}</div>}
          <Button type="submit" disabled={confirmPassword !== newPassword}>
            Change Password
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}

export default ChangePasswordDialog;
